import { getTypeName } from '@components/offer/helpers/sideDishHelper';
import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';
import SideDishEmpty from './SideDishEmpty';
import SideDishList from './SideDishList';
import SideDishLoader from './loader/SideDishLoader';

interface SideDishProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const SideDish: React.FC<SideDishProps> = observer(({ restaurantOfferStore }) => {
    const { orderFoodRequest, onSideDishClick, isFoodSideDishLoading } = restaurantOfferStore;

    if (orderFoodRequest.food.sideDishesEnabled === undefined || orderFoodRequest.food.sideDishesEnabled === false) {
        return <SideDishEmpty />
    }

    if (isFoodSideDishLoading) {
        return <SideDishLoader />
    }

    return (
        <Box>
            {_.chain(orderFoodRequest.food.sideDishes)
                .groupBy("sideDishType")
                .map((sideDishes, sideDishType) => (
                    <Box mt={1.5} key={`food-side-dish-type-${sideDishType}`}>
                        <Typography
                            variant='subtitle2'
                            fontWeight={600}>
                            {getTypeName(Number(sideDishType))}
                        </Typography>
                        {/* <Divider
                            sx={{ mb: 0.5 }}
                            textAlign="left">
                            <Typography variant='caption' color={"GrayText"}>
                                {getTypeName(Number(sideDishType))}
                            </Typography>
                        </Divider> */}
                        <SideDishList sideDishes={sideDishes} onClick={onSideDishClick} />
                    </Box>
                ))
                .value()}
        </Box>
    )
})

export default SideDish;